"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Link = exports.linkStrategy = void 0;

var _react = _interopRequireDefault(require("react"));

var _draftJs = require("draft-js");

var linkStrategy = function linkStrategy(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
  }, callback);
};

exports.linkStrategy = linkStrategy;

var Link = function Link(props) {
  var contentState = props.contentState,
      entityKey = props.entityKey;

  var _contentState$getEnti = contentState.getEntity(entityKey).getData(),
      url = _contentState$getEnti.url;

  var styles = {
    link: {
      color: '#F02D00',
      textDecoration: 'underline'
    }
  };
  return _react.default.createElement("a", {
    className: "link",
    rel: "noopener noreferrer",
    target: "_blank",
    "aria-label": url,
    href: url,
    style: styles.link
  }, props.children);
};

exports.Link = Link;
var addLinkPlugin = {
  decorators: new _draftJs.CompositeDecorator([{
    strategy: linkStrategy,
    component: Link
  }])
};
var _default = addLinkPlugin;
exports.default = _default;